<template>
  <div
    class="c-footer-banner"
    :class="navigationSelected365 ? 'wps' : 'solve'"
    :style="{ backgroundImage: `url(${bannerImage})` }"
  >
    <div class="c-footer-banner-content">
      <div v-if="navigationSelected365">
        <p class="c-footer-banner-text"></p>
        <p class="c-footer-banner-text">智慧教学办公新体验</p>
      </div>
      <div v-else>
        <p class="c-footer-banner-text">WPS智慧教育平台</p>
        <p class="c-footer-banner-text">—体化数智教育新体验</p>
      </div>
      <div v-if="navigationSelected365">
        <kd-button class="c-footer-banner-btn primary-btn" @click="handleDown"
          >立即下载</kd-button
        >
        <kd-button class="c-footer-banner-btn" @click="handleAsk"
          >立即咨询</kd-button
        >
      </div>
      <div v-else>
        <kd-button class="c-footer-banner-btn primary-btn" @click="handleAsk"
          >立即咨询</kd-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { common } from '@/common/constants/config';
import bannerPng from '@/assets/images/home/footer-banner.png';
import { getFromPage, getPageName } from '@/common/utils/index';
import infoCollect from '@/common/infoCollect';

export default {
  name: 'c-footer-banner',
  data() {
    return {
      bannerImage: bannerPng,
    };
  },
  props: {
    navigationSelected365: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    contactSales() {
      infoCollect.dwCollectData('button_click', 'banner_contact_sales', 'PC', {
        page_name: getPageName(),
        from_item: getFromPage(),
      });
      window.open(common.contactSales);
    },
    handleDown() {
      this.$emit('homeCallback', {
        banOpen: true,
        dwClickName: 'bottom_banner_down_load',
      });
      this.$router.push('/download');
    },
    handleAsk() {
      this.$emit('homeCallback', {
        dwClickName: 'bottom_banner_consult',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.c-hfb-banner {
  width: 100%;
  height: 125px;
}

.c-footer-banner {
  width: 100%;
  height: 320px;
  background-position: center;
  background-size: cover;
  position: relative;

  &.wps {
    .c-footer-banner-text {
      &:first-child::before {
        width: 211px;
        height: 44px;
        background-image: url('~@/assets/images/logo-365-black.svg');
      }
    }
  }

  &.solve {
    .c-footer-banner-content > div:first-child {
      padding-left: 90px;
      position: relative;
    }
    .c-footer-banner-text {
      &:first-child::before {
        position: absolute;
        width: 65px;
        height: 76px;
        left: 0px;
        top: 13px;
        background-image: url('~@/assets/images/logo-star.png');
      }
    }
  }
  &-content {
    max-width: 1200px;
    min-width: 768px;
    margin: 0 auto;
    display: flex;
    padding: 107px 0px;
    position: relative;
    height: 320px;
    > div {
      &:first-child {
        width: 400px;
      }
      &:last-child {
        text-align: right;
        margin-top: 24px;
        flex: 1;
      }
    }
    @media screen and (max-width: $width-m) {
      width: 840px;
    }
  }

  &-text {
    &:first-child::before {
      content: '';
      display: inline-block;
      background-size: 100%;
      background-repeat: no-repeat;
      vertical-align: middle;
      margin-right: 24px;
    }
    line-height: 45px;
    color: var(--kd-color-text-primary, rgba(13, 13, 13, 0.9));
    font-weight: 400;
    font-size: 28px;
    margin-bottom: 15px;
    line-height: 160%;
  }

  &-desc {
    font-size: 14px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.9);
  }

  &-btn {
    height: 56px;
    width: 200px;
    font-weight: 600;
    margin: 0 0 0 16px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    color: var(--kd-color-text-primary, rgba(13, 13, 13, 0.9));
    background: #fff;
    font-size: 18px;
  }
}
</style>
